<template>
  <label class="uk-form-label" :for="this.for">
    {{ text }}
    <small class="uk-display-block" v-text="hint" v-if="hint"></small>
  </label>
</template>

<script>
  export default {
    props: {
      text: {
        type: String,
        required: true
      },
      hint: {
        type: String,
      },
      for: {
        type: String,
      }
    },
  }
</script>



// WEBPACK FOOTER //
// public/themes/frontend/uikit3/extensions/rubinred/forms/assets/js/components/FormLabel.vue